<template>
  <b-modal
    id="modal-workplace-lock"
    ref="workplaceLockModal"
    :title="workplaceEnableForRequest && workplaceEnableForRequest.workplace_name ? `Editar/Início Lançamento (${workplaceEnableForRequest.workplace_name})` : ''"
    hide-footer
    size="md"
    centered
    no-close-on-backdrop
  >
    <div class="d-flex w-100">
      <div class="mr-2 flex-grow-1">
        <div class="mr-2">
          <label for="physician-id">Tipo Plantão/Serviço</label>
          <v-select
            id="person-type"
            v-model="workplaceEnableForRequest.person_type"
            name="person-type"
            :options="requestTypeOptions"
            label="label"
            item-value="value"
            item-text="label"
            :clearable="false"
          />
        </div>
        <div class="mr-2">
          <label for="physician-id">Tipo de Serviços</label>
          <v-select
            id="service-type-can-released"
            v-model="workplaceEnableForRequest.service_type_can_released"
            name="service-type-can-released"
            :options="serviceTypeCanReleasedOptions"
            label="label"
            item-value="value"
            item-text="label"
            :clearable="false"
          />
        </div>
      </div>
      <div class="mr-2 flex-grow-1">
        <div class="mr-2">
          <label>Informe a data</label>
          <b-form-datepicker
            id="request-enabled-at"
            v-model="workplaceEnableForRequest.request_enabled_at"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-BR"
            label-help=""
            label-no-date-selected="Selecione"
            reset-button
            label-reset-button="Limpar"
          />
        </div>
        <div class="mr-2">
          <label for="physician-id">Dia Limite Antecipação</label>
          <v-select
            id="advance-deadline-day"
            v-model="workplaceEnableForRequest.advance_deadline_day"
            name="advance-deadline-day"
            :options="advanceDeadlineDayOptions"
            :reduce="option => option.value"
            label="label"
            item-value="value"
            item-text="label"
            :clearable="false"
            :searchable="false"
          />
        </div>
      </div>
    </div>
    <div class="text-right">
      <b-button
        variant="primary"
        class="mt-2"
        :disabled="loading"
        @click="lockEnableForRequest"
      >
        <span class="d-none d-sm-inline">Salvar</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BFormDatepicker, BModal, VBModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useWorkplaceLock from './useWorkplaceLock'

export default {
  components: {
    BButton,
    BFormDatepicker,
    BModal,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, { emit }) {
    const {
      loading,
      workplaceLockModal,
      workplaceEnableForRequest,
      requestTypeOptions,
      serviceTypeCanReleasedOptions,
      advanceDeadlineDayOptions,
      show,
      lockEnableForRequest,
    } = useWorkplaceLock(() => emit('refetch-data'))

    return {
      loading,
      workplaceLockModal,
      workplaceEnableForRequest,
      requestTypeOptions,
      serviceTypeCanReleasedOptions,
      advanceDeadlineDayOptions,
      show,
      lockEnableForRequest,
    }
  },
}
</script>
